import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Card,
  CardHeader,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Media,
  Progress,
  Table,
  UncontrolledDropdown,
} from 'reactstrap'
import {
  setRestaurantProgress,
  setRestaurantProgressFetched,
  skipLocations,
} from 'store/Dashboard/actions'
import Loader from 'views/pages/Loader'
import { useRestaurantProgress } from '../../Admin/useRestaurantProgress'
import './style.css'
import { resetSkip } from 'store/Dashboard/actions'
import { setSkipLocations } from 'store/Dashboard/actions'
const RestaurantProgress = () => {
  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}

  const dispatch = useDispatch()

  const { fetchUserProgress, locationsTable } = useRestaurantProgress()

  const {
    restaurantProgressData: {
      locations,
      locationFilter,
      locationFilterWord,
      locationRoles,
      progressLoading,
      locationRoleName,
      showLoadMore,
    },
    skipLocations: skipLocationsNumber,
  } = useSelector((state) => state.dashboard)

  const [locationsState, setLocationsState] = useState(locations)
  const [skipState, setSkipState] = useState(skipLocationsNumber)

  const debounceTimeout = useRef(null)

  const handleInputChange = (e) => {
    const value = e.target.value
    const isBackspace = e.nativeEvent.inputType === 'deleteContentBackward'

    if (value.length === 1 && !isBackspace) {
      dispatch(setRestaurantProgress({ locations: [] }))
      dispatch(resetSkip())
    }

    if (!value) {
      dispatch(
        setRestaurantProgress({
          locationFilter: '',
        })
      )
      dispatch(setRestaurantProgress({ locations: locationsState }))
      dispatch(setSkipLocations(skipState))
      return
    }

    dispatch(
      setRestaurantProgress({
        locationFilter: value,
      })
    )

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current)
    }

    debounceTimeout.current = setTimeout(() => {
      if (value.length === 1 && isBackspace) return
      dispatch(setRestaurantProgressFetched(false))
    }, 500)
  }

  useEffect(() => {
    if (locations && locations.length && !locationFilter) {
      setLocationsState(locations)
    }
  }, [locations, locationFilter])

  useEffect(() => {
    if (skipLocationsNumber && !locationFilter)
      setSkipState(skipLocationsNumber)
  }, [skipLocationsNumber, locationFilter])

  return (
    <Card className='h-100 card-margin '>
      <CardHeader className='border-0'>
        <h3 className='mb-0'>Restaurant Progress</h3>
      </CardHeader>
      <div className='table-responsive h-100 ' ref={locationsTable}>
        <Table className='align-items-center table-flush'>
          <thead className='thead-light'>
            <tr>
              <th scope='col'>
                {language.settings ? language.settings.locations : null}
                <UncontrolledDropdown>
                  <DropdownToggle
                    color=''
                    size='sm'
                    className='btn-icon-only text-light'
                    // onClick={() => handleFilterClick()}
                  >
                    <i className='fas fa-bars' />
                  </DropdownToggle>
                  <DropdownMenu className='dropdown-menu-arrow p-2'>
                    <Input
                      className='form-control-sm mr-1'
                      bsSize='sm'
                      type='text'
                      autoFocus
                      placeholder='Search location'
                      value={locationFilter}
                      onChange={handleInputChange}
                    />
                  </DropdownMenu>
                </UncontrolledDropdown>
              </th>
              <th scope='col'>
                {language.settings ? language.settings.roles : null}
                <UncontrolledDropdown group>
                  <DropdownToggle
                    color=''
                    size='sm'
                    className='btn-icon-only text-light'
                  >
                    <i className='fas fa-ellipsis-v' />
                  </DropdownToggle>
                  <DropdownMenu
                    className='dropdown-menu-arrow custom-dropdown-menu'
                    style={{ height: '100px' }}
                  >
                    <div className='scrollable-dropdown-menu'>
                      <DropdownItem
                        onClick={() => {
                          dispatch(resetSkip())
                          setSkipState(0)
                          fetchUserProgress(null, 'All', true)
                        }}
                        className='py-1'
                      >
                        <span className='text-default'>ALL</span>
                      </DropdownItem>
                      {locationRoles &&
                        locationRoles.length > 0 &&
                        locationRoles
                          .filter((item) => item.count > 0)
                          .map((role, index) => (
                            <DropdownItem
                              key={index}
                              onClick={() =>
                                fetchUserProgress(role.id, role.name)
                              }
                              className='py-1'
                            >
                              <span className='text-default'>{role.name}</span>
                            </DropdownItem>
                          ))}
                    </div>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </th>
              {/* <th scope='col'>
                {language.general ? language.general.users : null}
              </th> */}
              <th className='sort' data-sort='status' scope='col'>
                Completions
              </th>
            </tr>
          </thead>

          <tbody className='list  '>
            {progressLoading && !locations.length ? (
              <td className='text-center h1' colSpan={2}>
                <Loader color='primary' />
              </td>
            ) : (
              locations.length > 0 &&
              locations
                .filter(
                  (item) =>
                    item.users != '' &&
                    item.locationData.name
                      .toLowerCase()
                      .includes(locationFilterWord.toLowerCase())
                )
                .map((item, index) => (
                  <tr key={item.locationData.module_id}>
                    <th scope='row'>
                      <Media className='align-items-center'>
                        <Media>
                          <span className='name mb-0 text-sm'>
                            {item.locationData.name}
                          </span>
                        </Media>
                      </Media>
                    </th>
                    <th>
                      <Media className='align-items-center'>
                        <Media>
                          <span className='name mb-0 text-sm'>
                            {locationRoleName}
                          </span>
                        </Media>
                      </Media>
                    </th>
                    {/* <td>
                      <div className='avatar-group'>
                        {item.users &&
                          item.users.length &&
                          item.users.slice(0, 5).map((user, index) => (
                            <a
                              key={index}
                              href='#pablo'
                              className='avatar avatar-sm rounded-circle'
                              id={`tooltip-${user?.module_id}`}
                              onClick={(e) => e.preventDefault()}
                            >
                              <img
                                alt='...'
                                style={{
                                  height: '100%',
                                  width: '100%',
                                  objectFit: 'cover',
                                }}
                                src={
                                  user && user.avatar
                                    ? JSON.parse(user.avatar).url
                                    : Avatar
                                }
                              />
                              <UncontrolledTooltip
                                delay={0}
                                target={`tooltip-${user?.module_id}`}
                              >
                                {user.name}
                              </UncontrolledTooltip>
                            </a>
                          ))}
                      </div>
                    </td> */}
                    <td className='status'>
                      <div className='d-flex align-items-center'>
                        <span className='completion mr-2'>
                          {item.locationData.module_data[0].name}
                        </span>
                        <div>
                          <Progress
                            max='100'
                            value={
                              item.locationData.module_data[0].name.split(
                                ' '
                              )[0]
                            }
                            color='info'
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
            )}
          </tbody>
          {progressLoading && locations.length && (
            <td className='text-center h1' colSpan={2}>
              <Loader color='primary' />
            </td>
          )}
          {!progressLoading && showLoadMore && (
            <button
              className='btn btn-outline-info m-3'
              onClick={() => {
                dispatch(setRestaurantProgressFetched(false))
                dispatch(skipLocations())
              }}
            >
              Load more...
            </button>
          )}
        </Table>
      </div>
    </Card>
  )
}

export default RestaurantProgress
